import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { strings } from 'APP_ROOT/localization';
import geofences from 'APP_ROOT/data/geofences';
import { setSelectedResource } from '../../actions';
import ProgressOverlay from 'APP_ROOT/components/common/ProgressOverlay';

import Type from './Attributes/Type';
import Address from './Attributes/Address';
import ZoneSize from './Attributes/ZoneSize/'; // my compiler won't let me drop the trailing forward-slash but it's fine after commit

class LocationAttributes extends React.Component {

    constructor() {
        super();
        this.state = {
            error: null
        };
    }

    static propTypes = {
        geofenceId: PropTypes.string, /* may be undefined for new geofence */
        stage: PropTypes.string.isRequired,
        saving: PropTypes.bool,
        editingGeometry: PropTypes.object,
        startGeometryEdit: PropTypes.func.isRequired,
        saveGeometryEdit: PropTypes.func.isRequired,
        cancelGeometryEdit: PropTypes.func.isRequired,
        selectGeofence: PropTypes.func.isRequired,
    }

    saveGeometryEdit = () => {
        this.props.saveGeometryEdit().then(geofenceId => {
            if(this.props.geofenceId !== geofenceId) {
                this.props.selectGeofence(geofenceId);
            }
        });
    }

    openFileDialog = () => {
        document.getElementById('importPolygonFileDialog').click();
    }

    handlePolygonImport = (e) => {
        const file = e.target.files[0];

        if (file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                try{
                    const data = JSON.parse(e.target.result);
                    if(isValidGeojson(data)) {
                        this.setState({error: null});
                        return this.props.importPolygon(data.geometry.coordinates, data.geometry.coordinates[0][0]);
                    }
                    this.setState({error: "invalid_geojson"});
                    return console.error("Importing Geojson failed: Invalid geojson content");
                }catch(e){
                    this.setState({error: "invalid_geojson"});
                    console.error("Importing Geojson failed: Invalid geojson content", e);
                }
            };

            reader.readAsText(file);
        }

        function isValidGeojson(data) {
            return data && 
            data.geometry && 
            data.geometry.coordinates && 
            Array.isArray(data.geometry.coordinates) && 
            data.geometry.coordinates.length > 0 && 
            Array.isArray(data.geometry.coordinates[0]) && 
            data.geometry.coordinates[0].length > 3; // A polygon must have at least 4 points
        }
    }

    render () {

        const { editingGeometry, saving, editable } = this.props;

        const wantToDrawANewPolygon = editingGeometry && editingGeometry.geometry.type === 'Polygon' && !editingGeometry.geometry.coordinates;

        return (
            <section className="location-attributes">

                
                    {editable && 
                        <header>
                            {editingGeometry ?
                            <>
                                <Type geofenceId={this.props.geofenceId} stage={this.props.stage} />
                                <button disabled={saving || !this.props.validity.isValid} className="btn btn-blue btn-sm" onClick={this.saveGeometryEdit}>{strings.resource_action_save_location}</button>
                                <button disabled={saving} className="btn btn-blue btn-sm" onClick={this.props.cancelGeometryEdit}>{strings.action_cancel}</button>
                            </>
                            :   <button className="btn btn-blue btn-sm" onClick={this.props.startGeometryEdit}>{strings.resource_action_edit_location}</button>
                            }
                        </header>
                    }

                {wantToDrawANewPolygon ?
                    <section className='text-center mt-3'>
                        <p><b>{strings.geofence_draw_polygon_instructions}</b></p>
                        <p>{strings.geofence_draw_polygon_instructions_or}</p>
                        <input id="importPolygonFileDialog" type="file" style={{display: "none"}} onChange={this.handlePolygonImport} accept="application/JSON" />
                        <input type="button" className="btn btn-blue btn-lg" value={strings.geofence_import_polygon} onClick={this.openFileDialog} />
                    </section>

                :   <section className={editingGeometry ? "edit-mode" : null}>

                    {!editingGeometry && <Type geofenceId={this.props.geofenceId} stage={this.props.stage} />}
                    
                    <Address geofenceId={this.props.geofenceId} />

                    <ZoneSize geofenceId={this.props.geofenceId} />

                    </section>                
                }
                

                {this.props.validity.error && <p className="error mt-2 text-center">{strings["geofence_error_" + this.props.validity.error]}</p>}
                {this.state.error && <p className="error mt-2 text-center">{strings["geofence_error_" + this.state.error]}</p>}

                {saving && <ProgressOverlay/>}
            </section>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        editingGeometry: geofences.Selectors.editingGeometry(state),
        saving: !!geofences.Selectors.savingGeometryEdit(state, ownProps.geofenceId),
        validity: geofences.Selectors.geofenceValidity(state, ownProps.geofenceId)
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        startGeometryEdit: () => dispatch(geofences.Actions.startGeometryEdit(ownProps.geofenceId)),
        saveGeometryEdit: () => dispatch(geofences.Actions.saveGeometryEdit(ownProps.stage, ownProps.geofenceId)),
        cancelGeometryEdit: () => dispatch(geofences.Actions.cancelGeometryEdit()),
        selectGeofence: geofenceId => dispatch(setSelectedResource('geofence', geofenceId)),
        importPolygon: (coordinates, center) => dispatch(geofences.Actions.importGeofence(coordinates, center))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(LocationAttributes);
